export var ConnectorType;
(function (ConnectorType) {
    ConnectorType["Email"] = "Email";
    ConnectorType["Sms"] = "Sms";
    ConnectorType["Social"] = "Social";
    ConnectorType["Whatsapp"] = "Whatsapp";
})(ConnectorType || (ConnectorType = {}));
